import React, { useState, useEffect, useContext } from 'react';
import { Stage, Layer, Image } from 'react-konva';
import useImage from 'use-image';
import InjectionUnit from '../../../assets/InjectionUnit.svg';
import Screw from '../../../assets/Screw.svg';
import FeedThroat from '../../../assets/FeedThroat.svg';
import ExtruderBarrel from '../../../assets/ExtruderBarrel.svg';
import BarrelHead from '../../../assets/BarrelHead.svg';
import TransferCylinder from '../../../assets/TransferCylinder.svg';
import ShootingPot from '../../../assets/ShootingPot.svg';
import Plungent from '../../../assets/Plungent.svg';
import NozzleTip from '../../../assets/NozzleTip.svg';
import ExtruderMotor from '../../../assets/ExtruderMotor.svg';
import InjectionPiston from '../../../assets/InjectionPiston.svg';
import Distributor from '../../../assets/Distributor.svg';
import BarrelHeadExtension from '../../../assets/BarrelHeadExtension.svg';
import { KonvaEventObject } from 'konva/lib/Node';
import { MachineCanvasProps } from '../../../../InjectionCycle/components/interfaces';
import { useNavigate } from 'react-router-dom';
import { findSubAssetsAvailable } from '../../../../utils/helper';
import { AppContext } from '../../../../../../App';

const InjectionUnitCanvas: React.FC<MachineCanvasProps> = ({ hoveredPart, setHoveredPart, machineName , navigationState}) => {
  const navigate = useNavigate();
const appContextProps: any = useContext(AppContext)
  const [stageSize, setStageSize] = useState({ width: window.innerWidth, height: 550 });

  const [InjectionUnitImg] = useImage(InjectionUnit);
  const [ScrewImg] = useImage(Screw);
  const [FeedThroatImg] = useImage(FeedThroat);
  const [ExtruderBarrelImg] = useImage(ExtruderBarrel);
  const [ExtruderMotorImg] = useImage(ExtruderMotor);
  const [ShootingPotImg] = useImage(ShootingPot);
  const [TransferCylinderImg] = useImage(TransferCylinder);
  const [PlungentImg] = useImage(Plungent);
  const [NozzleTipImg] = useImage(NozzleTip);
  const [InjectionPistonImg] = useImage(InjectionPiston);
  const [DistributorImg] = useImage(Distributor);
  const [BarrelHeadExtensionImg] = useImage(BarrelHeadExtension);
  const [BarrelHeadImg] = useImage(BarrelHead);



  const handleMouseMove = (e: KonvaEventObject<MouseEvent>) => {
    const { x, y } = e.target.getStage()?.getPointerPosition() || { x: 0, y: 0 };

    if (x >= stageSize.width * 0.2 && x <= stageSize.width * 0.21 && y >= stageSize.height * 0.32 && y <= stageSize.height * 0.36 && navigationState[("Barrel Head").toLowerCase()] ) {
      setHoveredPart('Barrel Head');
    } else if (x >= stageSize.width * 0.202 && x <= stageSize.width * 0.54 && y >= stageSize.height * 0.32 && y <= stageSize.height * 0.36 && navigationState[("Screw").toLowerCase()] ) {
      setHoveredPart('Screw');
    } else if ((x >= stageSize.width * 0.136 && x <= stageSize.width * 0.159 && y >= stageSize.height * 0.48 && y <= stageSize.height * 0.52) && navigationState[("Distributor").toLowerCase()]) {
      setHoveredPart('Distributor');
    } else if (x >= stageSize.width * 0.158 && x <= stageSize.width * 0.55 && y >= stageSize.height * 0.28 && y <= stageSize.height * 0.35 && navigationState[("Extruder Barrel").toLowerCase()]) {
      setHoveredPart('Extruder Barrel');
    } else if (x >= stageSize.width * 0.534 && x <= stageSize.width * 0.570 && y >= stageSize.height * 0.01 && y <= stageSize.height * 0.30 && navigationState[("Feed Throat").toLowerCase()]) {
      setHoveredPart('Feed Throat');
    } else if (x >= stageSize.width * 0.61 && x <= stageSize.width * 0.735 && y >= stageSize.height * 0.22 && y <= stageSize.height * 0.48 && navigationState[("Extruder Motor").toLowerCase()]) {
      setHoveredPart('Extruder Motor');
    } else if (x >= stageSize.width * 0.543 && x <= stageSize.width * 0.58 && y >= stageSize.height * 0.3 && y <= stageSize.height * 0.38 && navigationState[("Transfer Cylinder").toLowerCase()]) {
      setHoveredPart('Transfer Cylinder');
    } else if (x >= stageSize.width * 0.15 && x <= stageSize.width * 0.203 && y >= stageSize.height * 0.47 && y <= stageSize.height * 0.52 && navigationState[("Shooting Pot").toLowerCase()]) {
      setHoveredPart('Shooting Pot');
    } else if (x >= stageSize.width * 0.2 && x <= stageSize.width * 0.27 && y >= stageSize.height * 0.48 && y <= stageSize.height * 0.53 && navigationState[("Plunger").toLowerCase()]) {
      setHoveredPart('Plunger');
    } else if (x >= stageSize.width * 0.075 && x <= stageSize.width * 0.13 && y >= stageSize.height * 0.474 && y <= stageSize.height * 0.55 && navigationState[("Nozzle Tip").toLowerCase()]) {
      setHoveredPart('Nozzle Tip');
    } else if (x >= stageSize.width * 0.3065 && x <= stageSize.width * 0.36 && y >= stageSize.height * 0.453 && y <= stageSize.height * 0.56 && navigationState[("Injection Piston").toLowerCase()]) {
      setHoveredPart('Injection Piston');
    } else if (x >= stageSize.width * 0.14 && x <= stageSize.width * 0.17 && y >= stageSize.height * 0.375 && y <= stageSize.height * 0.45 && navigationState[("Barrel Head Extension").toLowerCase()]) {
      setHoveredPart('Barrel Head Extension');
    } else {
      setHoveredPart('');
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setStageSize({
        width: window.innerWidth - (appContextProps.sideBarOpenStatus ? 260 : 10),
        height: 550,
      });
    };
	handleResize(); // Call handleResize immediately to set the initial size
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [appContextProps.sideBarOpenStatus]);


  return (
		<Stage
			width={stageSize.width}
			height={stageSize.height}
			onMouseMove={handleMouseMove}
		>
			<Layer>
				<Image
					image={InjectionUnitImg}
					x={stageSize.width * 0.08}
					y={stageSize.height * 0.12}
					width={stageSize.width * 0.7}
					height={stageSize.height * 0.75}
				/>
				{hoveredPart === 'Screw' && (
					<Image
						image={ScrewImg}
						x={stageSize.width * 0.202}
						y={stageSize.height * 0.253}
						width={stageSize.width * 0.342}
						height={stageSize.height * 0.113}
						onClick={() =>
							navigate(
								`/usecase/injection-pdm/hypets/${machineName}/Injection%20Unit/Screw/reportview`,{ state: navigationState[('Screw').toLowerCase()] }
							)
						}
					/>
				)}
				{hoveredPart === 'Feed Throat' && (
					<Image
						image={FeedThroatImg}
						x={stageSize.width * 0.537}
						y={stageSize.height * 0.045}
						width={stageSize.width * 0.062}
						height={stageSize.height * 0.258}
						onClick={() =>
							navigate(
								`/usecase/injection-pdm/hypets/${machineName}/Injection%20Unit/Feed%20Throat/reportview`,{ state: navigationState[('Feed Throat').toLowerCase()] }
							)
						}
					/>
				)}
				{hoveredPart === 'Extruder Barrel' && (
					<Image
						image={ExtruderBarrelImg}
						x={stageSize.width * 0.158}
						y={stageSize.height * 0.2}
						width={stageSize.width * 0.387}
						height={stageSize.height * 0.18}
						onClick={() =>
							navigate(
								`/usecase/injection-pdm/hypets/${machineName}/Injection%20Unit/Extruder%20Barrel/reportview`,{ state: navigationState[('Extruder Barrel').toLowerCase()] }
							)
						}
					/>
				)}
				{hoveredPart === 'Extruder Motor' && (
					<Image
						image={ExtruderMotorImg}
						x={stageSize.width * 0.585}
						y={stageSize.height * 0.17}
						width={stageSize.width * 0.149}
						height={stageSize.height * 0.3}
						onClick={() =>
							navigate(
								`/usecase/injection-pdm/hypets/${machineName}/Injection%20Unit/Extruder%20Motor/reportview`,{ state: navigationState[('Extruder Motor').toLowerCase()] }
							)
						}
					/>
				)}
				{hoveredPart === 'Transfer Cylinder' && (
					<Image
						image={TransferCylinderImg}
						x={stageSize.width * 0.543}
						y={stageSize.height * 0.3}
						width={stageSize.width * 0.08}
						height={stageSize.height * 0.19}
						onClick={() =>
							navigate(
								`/usecase/injection-pdm/hypets/${machineName}/Injection%20Unit/Transfer%20Cylinder/reportview`,{ state: navigationState[('Transfer Cylinder').toLowerCase()] }
							)
						}
					/>
				)}
				{hoveredPart === 'Shooting Pot' && (
					<Image
						image={ShootingPotImg}
						x={stageSize.width * 0.15}
						y={stageSize.height * 0.398}
						width={stageSize.width * 0.07}
						height={stageSize.height * 0.126}
						onClick={() =>
							navigate(
								`/usecase/injection-pdm/hypets/${machineName}/Injection%20Unit/Shooting%20Pot/reportview`,{ state: navigationState[('Shooting Pot').toLowerCase()] }
							)
						}
					/>
				)}
				{hoveredPart === 'Plunger' && (
					<Image
						image={PlungentImg}
						x={stageSize.width * 0.182}
						y={stageSize.height * 0.403}
						width={stageSize.width * 0.09}
						height={stageSize.height * 0.12}
						onClick={() =>
							navigate(
								`/usecase/injection-pdm/hypets/${machineName}/Injection%20Unit/Plunger/reportview`,{ state: navigationState[('Plunger').toLowerCase()] }
							)
						}
					/>
				)}
				{hoveredPart === 'Nozzle Tip' && (
					<Image
						image={NozzleTipImg}
						x={stageSize.width * 0.029}
						y={stageSize.height * 0.474}
						width={stageSize.width * 0.125}
						height={stageSize.height * 0.06}
						onClick={() =>
							navigate(
								`/usecase/injection-pdm/hypets/${machineName}/Injection%20Unit/Nozzle%20Tip/reportview`,{ state: navigationState[('Nozzle Tip').toLowerCase()] }
							)
						}
					/>
				)}
				{hoveredPart === 'Injection Piston' && (
					<Image
						image={InjectionPistonImg}
						x={stageSize.width * 0.3065}
						y={stageSize.height * 0.453}
						width={stageSize.width * 0.086}
						height={stageSize.height * 0.18}
						onClick={() =>
							navigate(
								`/usecase/injection-pdm/hypets/${machineName}/Injection%20Unit/Injection%20Piston/reportview`,{ state: navigationState[('Injection Piston').toLowerCase()] }
							)
						}
					/>
				)}
				{hoveredPart === 'Distributor' && (
					<Image
						image={DistributorImg}
						x={stageSize.width * 0.136}
						y={stageSize.height * 0.48}
						width={stageSize.width * 0.04}
						height={stageSize.height * 0.14}
						onClick={() =>
							navigate(
								`/usecase/injection-pdm/hypets/${machineName}/Injection%20Unit/Distributor/reportview`,{ state: navigationState[('Distributor').toLowerCase()] }
							)
						}
					/>
				)}
				{hoveredPart === 'Barrel Head Extension' && (
					<Image
						image={BarrelHeadExtensionImg}
						x={stageSize.width * 0.112}
						y={stageSize.height * 0.375}
						width={stageSize.width * 0.093}
						height={stageSize.height * 0.14}
						onClick={() =>
							navigate(
								`/usecase/injection-pdm/hypets/${machineName}/Injection%20Unit/Barrel%20Head%20Extension/reportview`,{ state: navigationState[('Barrel Head Extension').toLowerCase()] }
							)
						}
					/>
				)}
				{hoveredPart === 'Barrel Head' && (
					<Image
						image={BarrelHeadImg}
						x={stageSize.width * 0.1835}
						y={stageSize.height * 0.2642}
						width={stageSize.width * 0.04}
						height={stageSize.height * 0.102}
						onClick={() =>
							navigate(
								`/usecase/injection-pdm/hypets/${machineName}/Injection%20Unit/Barrel%20Head/reportview`,{ state: navigationState[('Barrel Head').toLowerCase()] }
							)
						}
					/>
				)}
			</Layer>
		</Stage>
	)
}

export default InjectionUnitCanvas;
